import {MS_IN_DAY} from 'shared/const';
import {getTodayStartTime} from 'shared/utils/dateTime';
import {TimeZoneShift, DayStartInBudgetCreationTimeZone} from '../types';

export function calcShiftFromOriginalTimeZone(
  baseDateTime: DayStartInBudgetCreationTimeZone
): TimeZoneShift {
  const localDayStart = getTodayStartTime();
  if (localDayStart === baseDateTime) return 0;

  const wentToEast = localDayStart % MS_IN_DAY > baseDateTime % MS_IN_DAY;
  const direction = wentToEast ? -1 : 1;
  const absoluteShift = wentToEast
    ? (localDayStart - baseDateTime) % MS_IN_DAY
    : (baseDateTime - localDayStart) % MS_IN_DAY;

  return direction * absoluteShift;
}
